<template>
    <v-autocomplete
        v-model="value"
        :items="items"
        item-text="key"
        :label="label"
        :disabled="disabled"
        :clearable="clearable"
        return-object
        hide-details
    />
  </template>
  
  <script>
  import VueTypes from "vue-types";
  import {MapKindModel} from "@/modules/redactor/models/map/MapKindModel";
  import { RedactorUtils } from "@/modules/redactor/core/RedactorUtils";
  
  export default {
    name: "r-map-kind-dropdown",
    props: {
      label: VueTypes.string.def("Map Kind"),
      model: VueTypes.instanceOf(MapKindModel),
      disabled: VueTypes.bool.def(false),
      clearable: VueTypes.bool.def(true)
    },
    data: () => ({
      items: []
    }),
    computed: {
      value: {
        get: function () {
          return this.model;
        },
        set: function (value) {

          /*if(RedactorUtils){
            let map_kind = RedactorUtils.getMapKind();
            if(value && map_kind.name != "MAP_GLOBAL"){
              this.$alert("Only global config support map kind for trigger generic !");
              this.$emit("update:model", null);
              return;
            }
          }*/

          this.$emit("update:model", value);
          this.$store.commit("redactor-store/setMapKind", value);
        }
      }
    },
    created() {
      this.items = RedactorUtils.getMapKinds();
    }
  }
  </script>
  